import React from "react";
// Customizable Area Start
import { Box, styled, Typography } from "@mui/material";
import NavigationMenu from "./NavigationMenu.web";
import AboutUsController, { Props } from "./AboutUsController";
import AppFooter from "../../../components/src/AppFooter.web";
import { leftImg, rightImg, secondImg, topBgImg } from "./assets";
import BannerWithContent from "../../../components/src/BannerWithContent.web";
import GoogleAd from "../../../components/src/GoogleAd.web";
// Customizable Area End

export default class AboutUs extends AboutUsController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    const { navigation } = this.props;
    return (
      <AboutUsStyle>
        <NavigationMenu id="" navigation={navigation} />
        <BannerWithContent isOverlap backgroundImage={topBgImg}>
          <Box>
            <Box className="firstPortionContainer">
              <Box className="imgsBox">
                <Box>
                  <img className="imgStyle" src={rightImg} />
                </Box>
                <Box className="overlapImg">
                  <img className="imgStyle" src={leftImg} />
                </Box>
              </Box>
              <Box className="descriptionTopBox">
                <Typography className="decsText">
                  BharatStage is India’s first dedicated digital platform
                  designed to bridge the gap between talent and opportunity in
                  the film and entertainment industry. We empower aspiring and
                  professional artists, including actors, singers, directors,
                  cinematographers, editors, models, and other creative
                  professionals to showcase their profiles and get discovered by
                  producers, casting directors, production houses, and content
                  creators from across the country and abroad.
                </Typography>
              </Box>
            </Box>
            <Box className="firstPortionContainer secondPortionContainer">
              <Box className="descriptionTopBox">
                <Typography className="decsText">
                  In a fast-growing entertainment ecosystem where thousands of
                  skilled individuals remain unseen, BharatStage offers a
                  centralized, easy-to-use online stage to present talent.
                  Artists can create professional portfolios with photographs,
                  demo videos, biographies, and experience records—all in one
                  place. This not only enhances their visibility but also
                  eliminates traditional middlemen from the casting and hiring
                  process.
                </Typography>
              </Box>
              <Box className="imgsBox">
                <Box className="overlapBottomImg">
                  <img className="imgStyle" src={leftImg} />
                </Box>
                <Box>
                  <img className="imgStyle" src={rightImg} />
                </Box>
              </Box>
            </Box>
            <Box
              sx={{ mb: "0px !important" }}
              className="firstPortionContainer"
            >
              <Box className="imgsBox">
                <Box>
                  <img className="bottomImg" src={secondImg} />
                </Box>
              </Box>
              <Box className="descriptionBottomBox">
                <Typography className="aboutPageDesc">
                  BharatStage is more than a listing service. It’s a networking
                  platform built on trust, innovation, and opportunity. With
                  advanced search filters, direct messaging tools, and verified
                  profiles, we ensure a smooth and transparent connection
                  between talent seekers and providers.
                </Typography>
                <br />
                <Typography className="aboutPageDesc">
                  We are committed to creating an ecosystem where every talent,
                  no matter how big or small, gets a fair chance to rise.
                  However, while our platform facilitates discovery and
                  communication, we do not guarantee work, casting, or
                  selection, as all final decisions are independently made by
                  the producers or employers.
                </Typography>
                <br />
                <Typography className="aboutPageDesc">
                  Whether you are just starting your journey or are an
                  established professional seeking wider reach—BharatStage is
                  your stage to rise. Join us. Create your profile. Let your
                  talent be seen. BharatStage – Rise with Your Art.
                </Typography>
              </Box>
            </Box>
          </Box>
          <GoogleAd
            responsive
            format="auto"
            sx={{ mt: 6 }}
            slot="8327314980"
          />
        </BannerWithContent>
        <AppFooter navigation={navigation} />
      </AboutUsStyle>
    );
    // Customizable Area End
  }
}

// Customizable Area Start
export const AboutUsStyle = styled(Box)({
  fontFamily: "Montserrat !important",
  "& .firstPortionContainer": {
    display: "flex",
    justifyContent: "space-between",
    gap: "30px",
    marginBottom: "80px",
    alignItems: "center",
  },
  "& .imgsBox": {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    "@media (min-width: 320px) and (max-width: 360px)": {
      display: "flex",
      width: "80px",
    },
  },
  "& .decsText": {
    font: "Montserrat",
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "30px",
    color: "#64748B",
    letterSpacing: "0%",
    marginTop: "10px",
    "@media (min-width: 1920px)": {
      fontSize: "18px",
      fontWeight: "500",
      lineHeight: "30px",
    },
  },
  "& .aboutPageDesc": {
    font: "Montserrat",
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "30px",
    color: "#64748B",
  },
  "& .descriptionTopBox": {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  "& .bottomImg": {
    maxHeight: "500px",
    flex: 1,
    "@media (min-width: 315px) and (max-width: 415px)": {
      width: "190px !important",
    },
  },
  "& .descriptionBottomBox": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
  },
  "& .overlapImg": {
    marginTop: "70px",
    marginLeft: "-70px",
  },
  "& .overlapBottomImg": {
    marginTop: "60px",
    marginRight: "-70px",
    zIndex: 1,
  },

  "@media (min-width: 1281px)": {
    "& .firstPortionContainer": {
      gap: "30px",
      marginBottom: "40px",
    },
    "& .decsText": {
      fontSize: "16px",
      lineHeight: "30px",
      marginTop: "10px",
    },
    "& .overlapImg": {
      marginTop: "70px",
      marginLeft: "-70px",
    },
    "& .overlapBottomImg": {
      marginTop: "60px",
      marginRight: "-70px",
      zIndex: 1,
    },
  },

  "@media (min-width: 768px) and (max-width: 1280px)": {
    "& .firstPortionContainer": {
      gap: "30px",
      marginBottom: "70px",
    },
    "& .imgStyle": {
      width: "180px",
    },
    "& .bottomImg": {
      width: "300px",
    },
    "& .decsText": {
      fontSize: "15px",
      lineHeight: "25px",
      marginTop: "8px",
    },
    "& .aboutPageDesc": {
      fontSize: "15px",
      lineHeight: "20px",
    },
    "& .overlapImg": {
      marginTop: "58px",
      marginLeft: "-61px",
    },
    "& .overlapBottomImg": {
      marginTop: "45px",
      marginRight: "-50px",
      zIndex: 1,
    },
  },

  "@media (max-width: 767px)": {
    "& .firstPortionContainer": {
      flexDirection: "column",
      marginBottom: "40px",
      gap: "20px",
    },
    "& .secondPortionContainer": {
      flexDirection: "column-reverse",
    },
    "& .imgStyle": {
      width: "150px",
      "@media (max-width: 400px)": {
        width: "130px",
      }
    },
    "& .bottomImg": {
      width: "265px",
      "@media (max-width: 400px)": {
        width: "180px",
      }
    },
    "& .decsText": {
      fontSize: "14px",
      lineHeight: "20px",
      marginTop: "8px",
      textAlign: "center",
    },
    "& .aboutPageDesc": {
      fontSize: "14px",
      lineHeight: "20px",
      textAlign: "center",
    },
    "& .descriptionTopBox": {
      marginTop: "15px",
      width: "100%",
    },
    "& .descriptionBottomBox": {
      width: "100%",
      marginTop: "10px",
    },
    "& .overlapImg": {
      marginTop: "58px",
      marginLeft: "-61px",
    },
    "& .overlapBottomImg": {
      marginTop: "45px",
      marginRight: "-50px",
      zIndex: 1,
    },
  },
});
// Customizable Area End
